export const LABELS = {
  TITLE: 'Get all your home services connected in minutes',
  SUBTITLE:
    "Let's make your house a home. Sorted is Australia's first digital home services marketplace",
};
